import React from "react";
import { css } from "@emotion/react";
import Divider from "atoms/Divider";
import Header from "organisms/Header";
import RunYourD2CBusiness from "organisms/HomePageWidgets/RunYourD2CBusiness";
import TrustedByBrands from "organisms/HomePageWidgets/TrustedByBrands";
import WeHelpYouSucceed from "organisms/HomePageWidgets/WeHelpYouSucceed";
import OurOfferings from "organisms/HomePageWidgets/OurOfferings";
import OurMission from "organisms/HomePageWidgets/OurMission";
import OurPhilosophy from "organisms/HomePageWidgets/OurPhilosophy";
import Founders from "organisms/HomePageWidgets/Founders";
import GrowthConsulting from "organisms/HomePageWidgets/GrowthConsulting";
import Pricing from "organisms/HomePageWidgets/Pricing";
import Testimonial from "organisms/HomePageWidgets/Testimonial";
import Footer from "organisms/Footer";
import YourJourney from "organisms/HomePageWidgets/YourJourney";
import OurImpact from "organisms/HomePageWidgets/OurImpact";
import BackedByBest from "organisms/HomePageWidgets/BackedByBest";
import { fireEventOnPageLanding } from "events/fireEventOnPageLanding";
import useQuery from "hooks/useQuery";
import { useNavigate } from "react-router-dom";
import ContactUs from "organisms/HomePageWidgets/ContactUs";


export default () => {

  const query = useQuery();
  const navigate = useNavigate();

	React.useEffect(() => {
		const fb_et = query.get("fb_et");
		if (fb_et) {
			fireEventOnPageLanding(fb_et);
			// Remove fb_et from the URL without reload
			navigate("/");
		}
	}, []);

	return (
		<>
			<Header demoButtonVisibility={"none"}/>
			{/* Passing ShowBook Prop as false because we don't want to show book btn for Home Page in SMall SCreen View & for Desktop View Header Itself is diff so won't affect That */}
			<RunYourD2CBusiness	/>
			<TrustedByBrands />
			<WeHelpYouSucceed />
			<OurOfferings />
			<GrowthConsulting />
			<Testimonial />
			<Pricing />
			<YourJourney />
			<Founders />
			<OurMission />
			<OurPhilosophy />
			<OurImpact />
			<BackedByBest />
			<ContactUs />
			<Footer />
		</>
	)
}
